import { motorConstants } from '../constants';
const setPackage = (data, policyTypes, registerYear) => {
  return { type: motorConstants.SET_PACKAGE, data, policyTypes, registerYear };
};
export const motorActions = { setPackage };
